<script>
    import {onMount} from "svelte";
    import {URL_CONFIG} from "../utils/Constants.js";
    import {toast} from "../lib/consoltic_toast.js";
    import axios from "axios";

    // Si llegamos al login por una sesión caída/cerrada (interceptor 401/403), mostramos el motivo.
    onMount(() => {
        try {
            const reason = new URLSearchParams(window.location.search).get("end_reason");
            if (reason) toast.error(reason);
        } catch (_e) { /* noop */ }
    });

    let username = $state("");
    let password = $state("");
    let extension = $state("");
    let outbound_campaign_id = $state(null);
    let inbound_campaigns = $state([]);
    let loading = $state(false);
    let error_username = $state(false);
    let error_password = $state(false);
    let error_extension = $state(false);
    let error_message_extension = $state("");
    let error_message_username = $state("");
    let error_message_password = $state("");
    let error_message_global = $state("");
    let inbound_campaign_list = $state([]);
    let outbound_campaign_list = $state([]);
    let step = $state(1);   // 1 = login, 2 = selección de campañas (slide)
    let redirectReason = '';

    // Si hay una outbound obligatoria (permit_select=0), la saliente queda bloqueada en ella.
    let outbound_locked = $derived(outbound_campaign_list.some((o) => o.permit_select === 0));

    // La selección de campañas vive en un MODAL (no en una segunda pantalla con scroll).
    let show_campaigns_modal = $state(false);
    function closeCampaignsModal() { show_campaigns_modal = false; }
    function modalKeys(e) { if (e.key === 'Escape' && !loading) closeCampaignsModal(); }
    function portal(node) { document.body.appendChild(node); return { destroy() { node.remove(); } }; }

    // Extrae un mensaje legible de una respuesta de error (incluye 500, que antes no se veía).
    function serverErrorMessage(error) {
        const r = error?.response;
        if (!r) return "No se pudo conectar con el servidor. Revise su conexión.";
        const d = r.data;
        let msg = (d && (d.retMsg || d.detail || d.message || d.error))
            || (typeof d === "string" && d.length < 600 ? d : null);
        if (!msg) msg = `Error del servidor (${r.status} ${r.statusText || ""}).`.trim();
        return `[${r.status}] ${msg}`;
    }

    // Versión: la inyecta Django desde settings.SOFTWARE_VERSION (window.QR_VERSION).
    // Build: lo inyecta Vite (define) en tiempo de compilación (hash git + fecha).
    const appVersion = (typeof window !== "undefined" && window.QR_VERSION) ? window.QR_VERSION : "dev";
    const buildId = typeof __BUILD_ID__ !== "undefined" ? __BUILD_ID__ : "local";


    if (typeof window !== 'undefined') {
        redirectReason = sessionStorage.getItem('redirectReason');

        if (redirectReason === 'sessionExpired') {
            error_message_global = "Has sido deslogueado debido a que tu sesión expiró. Por favor ingresa nuevamente.";
            sessionStorage.removeItem('redirectReason');
        }
    }

    const handleSelectCampaigns = (e) => {
        let loginFields = {username, password, extension};
        loading = true;
        error_password = false;
        error_message_password = "";
        error_message_username = "";
        error_message_extension = "";
        error_username = false;
        error_extension = false;
        error_message_global = "";

        axios({
            method: 'post',
            url: URL_CONFIG.url_login_campaign_assigned,
            data: loginFields,
            responseType: 'json'

        }).then(function (response) {

            if (response.status === 200) {
                let data = response.data;

                if (data.retCode === 0) {

                    const obj_data = data.retData;
                    inbound_campaign_list = [];
                    outbound_campaign_list = [];
                    inbound_campaigns = [];
                    outbound_campaign_id = null;

                    for (let key in obj_data) {

                        const camp = obj_data[key];
                        // Canal EFECTIVO (enable_X AND allow_X) y permit_select vienen del backend.
                        const base = {
                            id: camp.id,
                            description: camp.description,
                            type: camp.type,
                            enable_audio: camp.effective_audio,
                            enable_chat: camp.effective_chat,
                            permit_select: camp.permit_select,
                            outbound_type: camp.outbound_type ?? null,
                        };

                        if (camp.type === "I" || camp.type === "IO") {
                            inbound_campaign_list = [...inbound_campaign_list, { ...base, name: camp.name }];
                        } else if (camp.type === "O") {
                            outbound_campaign_list = [...outbound_campaign_list, {
                                ...base, value: camp.id,
                                name: camp.description + " (" + camp.outbound_type + ") ",
                            }];
                        }
                    }

                    // permit_select=0 = obligatoria (entra sí o sí); =1 = opcional (el agente elige).
                    // Pre-seleccionar las inbound obligatorias y la outbound obligatoria (si hay una).
                    inbound_campaigns = inbound_campaign_list
                        .filter((c) => c.permit_select === 0)
                        .map((c) => c.id);

                    const mandatory_outbound = outbound_campaign_list.find((c) => c.permit_select === 0);
                    if (mandatory_outbound) outbound_campaign_id = mandatory_outbound.id;

                    const has_optional = inbound_campaign_list.some((c) => c.permit_select === 1);

                    // Login DIRECTO si no hay nada que elegir: ninguna opcional y ninguna outbound.
                    if (!has_optional && outbound_campaign_list.length === 0) {
                        loading = false;
                        handleLogin();
                    } else {
                        show_campaigns_modal = true;
                    }
                } else {
                    error_message_global = data.retMsg;

                    if (data.retData?.username) {
                        error_username = true;
                        error_message_username = data.retData.username[0];
                    }

                    if (data.retData?.password) {
                        error_password = true;
                        error_message_password = data.retData.password[0];
                    }

                    if (data.retData?.extension) {
                        error_extension = true;
                        error_message_extension = data.retData?.extension[0];
                    }
                }
            } else if (response.status === 401 || response.status === 403) {
                error_message_global = "Credenciales invalidas";
                error_username = true;
                error_message_username = "Credenciales invalidas";
            } else {
                error_message_global = "Respuesta del servidor erronea: " + response.status;
                toast.error(error_message_global);
            }
            loading = false;

        }).catch(function (error) {
            if (error.response?.status === 401 || error.response?.status === 403) {
                error_message_global = "Credenciales invalidas";
                error_username = true;
                error_message_username = "Credenciales invalidas";
            } else {
                error_message_global = serverErrorMessage(error);
                toast.error(error_message_global);
            }
            loading = false;
        });
    }

    const handleLogin = (e) => {
        let loginFields = {username, password, extension};

        // console.info(inbound_campaigns);
        // console.info(outbound_campaign_id);

        let campaign_list = [];

        if (outbound_campaign_id !== undefined && outbound_campaign_id !== null) {
            campaign_list.push(outbound_campaign_id);
        }

        if (inbound_campaigns.length > 0) {

            inbound_campaigns.forEach(function (i) {
                campaign_list.push(i);
            });

        }

        let login_fields = {
            username: username,
            password: password,
            extension: extension,
            campaign_list: campaign_list
        }

        loading = true;
        error_password = false;
        error_username = false;
        error_extension = false;
        error_message_username = "";
        error_message_password = "";
        error_message_extension = "";

        /*
        {
            "username": "hfonnegra",
            "passwsord": "clave",
            "extension": 2000,
            "campaign_list": [1,3,5]
        }
         */


        axios({
            method: 'post',
            url: URL_CONFIG.url_login,
            data: login_fields,
            responseType: 'json'

        }).then(function (response) {
            if (response.status === 200) {
                let data = response.data;
                if (data.retCode === 0) {
                    location.reload();

                } else {
                    error_message_global = data.retMsg;

                    if (data.retData) {

                        if (data.retData.username) {
                            error_username = true;
                            error_message_username = data.retData.username[0];
                        }

                        if (data.retData.password) {
                            error_password = true;
                            error_message_password = data.retData.password[0];
                        }

                        if (data.retData.extension) {
                            error_extension = true;
                            error_message_extension = data.retData.extension[0];
                        }

                        if (data.retData.campaign) {
                            error_message_global = data.retData.campaign[0];
                        }
                    }

                }
            } else {
                error_message_global = "Respuesta del servidor erronea: " + response.status;
                toast.error(error_message_global);
            }
            loading = false;

        }).catch(function (error) {
            if (error.response?.status === 401) {
                error_message_username = "Credenciales invalidas";
                error_message_password = "Credenciales invalidas";
                error_password = true;
                error_username = true;
                error_message_global = "Credenciales invalidas";
            } else {
                // Incluye 500 y demás: ahora SÍ se muestra el mensaje del servidor.
                error_message_global = serverErrorMessage(error);
                toast.error(error_message_global);
            }
            loading = false;
        });
    }

    function goBack() {
        closeCampaignsModal();
    }

</script>

<div class="min-vh-100 d-flex align-items-center justify-content-center bg-dark px-3 py-3">
    <div class="card shadow-lg border-0 rounded-4 w-100 overflow-hidden" style="max-width: 1000px;">
        <div class="row g-0">
            <!-- Left / Branding call center (solo imagen + versión) -->
            <div class="col-md-5 qr-col-40 d-none d-md-flex flex-column justify-content-center align-items-center text-white p-4 qr-login-brand">
                <!-- Ilustración call center -->
                <div class="text-center">
                    <svg class="qr-login-art" viewBox="0 0 320 280" xmlns="http://www.w3.org/2000/svg"
                         fill="none" role="img" aria-label="Agente de call center con auriculares">
                        <!-- Halos -->
                        <circle cx="160" cy="138" r="104" fill="#ffffff" opacity="0.06"/>
                        <circle cx="160" cy="138" r="74" fill="#ffffff" opacity="0.08"/>

                        <!-- Ondas de sonido -->
                        <path d="M70 110 a44 44 0 0 0 0 56" stroke="#ffffff" stroke-width="4"
                              stroke-linecap="round" opacity="0.45"/>
                        <path d="M58 96 a64 64 0 0 0 0 84" stroke="#ffffff" stroke-width="4"
                              stroke-linecap="round" opacity="0.25"/>
                        <path d="M250 110 a44 44 0 0 1 0 56" stroke="#ffffff" stroke-width="4"
                              stroke-linecap="round" opacity="0.45"/>
                        <path d="M262 96 a64 64 0 0 1 0 84" stroke="#ffffff" stroke-width="4"
                              stroke-linecap="round" opacity="0.25"/>

                        <!-- Auriculares -->
                        <path d="M104 150 a56 56 0 0 1 112 0" stroke="#ffffff" stroke-width="10"
                              stroke-linecap="round"/>
                        <rect x="92" y="146" width="26" height="48" rx="11" fill="#ffffff"/>
                        <rect x="202" y="146" width="26" height="48" rx="11" fill="#ffffff"/>
                        <!-- Brazo del micrófono -->
                        <path d="M215 190 q4 34 -34 40" stroke="#ffffff" stroke-width="7"
                              stroke-linecap="round"/>
                        <circle cx="176" cy="232" r="9" fill="#ffffff"/>

                        <!-- Avatar del agente -->
                        <circle cx="160" cy="128" r="30" fill="#ffffff" opacity="0.95"/>
                        <circle cx="160" cy="118" r="11" fill="#3d5af1"/>
                        <path d="M142 150 a18 16 0 0 1 36 0 z" fill="#3d5af1"/>

                        <!-- Burbuja de chat (arriba derecha) -->
                        <g opacity="0.95">
                            <rect x="232" y="44" width="62" height="40" rx="12" fill="#ffffff"/>
                            <path d="M250 84 l0 14 l16 -14 z" fill="#ffffff"/>
                            <circle cx="250" cy="64" r="4" fill="#6610f2"/>
                            <circle cx="263" cy="64" r="4" fill="#6610f2"/>
                            <circle cx="276" cy="64" r="4" fill="#6610f2"/>
                        </g>

                        <!-- Burbuja de llamada (abajo izquierda) -->
                        <g opacity="0.95">
                            <circle cx="58" cy="216" r="22" fill="#ffffff"/>
                            <path d="M50 208 c0 10 8 18 18 18 c2 0 4 -2 3 -4 l-2 -5 c-1 -2 -3 -2 -5 -1 c-2 -3 -4 -5 -5 -8
                                     c1 -1 2 -2 1 -4 l-2 -5 c-1 -2 -3 -2 -4 -1 c-2 1 -3 3 -4 5 z" fill="#3d5af1"/>
                        </g>
                    </svg>
                </div>

                <!-- Versión / build -->
                <div class="qr-build-info">v{appVersion} · build {buildId}</div>
            </div>

            <!-- Right / Slider (login <-> campañas) -->
            <div class="col-12 col-md-7 qr-col-60 bg-light qr-login-pane">
                <div class="qr-slider" class:qr-slide-2={step === 2}>

                    <!-- Slide 1: Login -->
                    <div class="qr-slide">
                        <div class="qr-slide-header px-4 pt-4 px-md-5 pt-md-5 pb-2">
                            <div class="text-center">
                                <h1 class="fw-bold h4 text-dark mb-1">QUEUEREPORT AGENTE</h1>
                                <div class="text-muted small">Ingreso al sistema</div>
                            </div>
                        </div>

                        <div class="qr-slide-body px-4 px-md-5 pt-3">
                            {#if error_message_global !== "" && !show_campaigns_modal}
                                <div class="alert alert-danger py-2 small">
                                    <strong>{error_message_global}</strong>
                                </div>
                            {/if}

                            <div class="mb-3">
                                <label for="username" class="form-label">Usuario/Email</label>
                                <input id="username" name="username" type="text"
                                       class="form-control {error_username ? 'is-invalid' : ''}"
                                       bind:value={username} required/>
                                {#if error_username}<div class="invalid-feedback">{error_message_username}</div>{/if}
                            </div>

                            <div class="mb-3">
                                <label for="password" class="form-label">Clave</label>
                                <input id="password" name="password" type="password"
                                       class="form-control {error_password ? 'is-invalid' : ''}"
                                       bind:value={password}/>
                                {#if error_password}<div class="invalid-feedback">{error_message_password}</div>{/if}
                            </div>

                            <div class="mb-3">
                                <label for="extension" class="form-label">Extension</label>
                                <input id="extension" name="extension" type="text"
                                       class="form-control {error_extension ? 'is-invalid' : ''}"
                                       bind:value={extension}/>
                                {#if error_extension}<div class="invalid-feedback">{error_message_extension}</div>{/if}
                            </div>
                        </div>

                        <div class="qr-slide-footer px-4 pb-4 px-md-5 pb-md-5 pt-3">
                            <button class="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                                    onclick={handleSelectCampaigns} disabled={loading} type="button">
                                {#if loading}
                                    <span class="spinner-border spinner-border-sm me-2"></span>
                                {:else}
                                    <i class="bi bi-building-check me-2"></i>
                                {/if}
                                Seleccionar Campañas
                            </button>
                        </div>
                    </div>

                    <!-- Modal: Selección de campañas (80vh x 60vw) -->
                    {#if show_campaigns_modal}
                    <div use:portal class="modal fade show d-block" tabindex="-1" aria-modal="true" role="dialog"
                         onkeydown={modalKeys} style="background: rgba(15, 23, 42, 0.55); z-index: 10800;">
                      <div class="modal-dialog modal-dialog-centered qr-login-camp-dialog">
                        <div class="modal-content qr-login-camp-content">
                            <div class="modal-header">
                                <div>
                                    <h2 class="qr-camp-h fw-bold mb-0">Elegí tus campañas</h2>
                                    <div class="text-muted small">Seleccioná en qué vas a trabajar hoy. Las obligatorias ya están incluidas.</div>
                                </div>
                                <button type="button" class="btn-close" aria-label="Cerrar" onclick={closeCampaignsModal} disabled={loading}></button>
                            </div>

                            <div class="modal-body flex-fill overflow-auto p-3 px-md-4">
                                {#if error_message_global !== ""}
                                    <div class="alert alert-danger py-2 small"><strong>{error_message_global}</strong></div>
                                {/if}

                            <!-- Campaña saliente (solo una) -->
                            {#if outbound_campaign_list.length > 0}
                                <section class="qr-camp-section">
                                    <div class="qr-camp-head">
                                        <i class="bi bi-telephone-outbound-fill qr-camp-head__ico qr-camp-head__ico--out"></i>
                                        <span class="qr-camp-head__title">Campaña saliente</span>
                                        <span class="qr-camp-head__hint">solo una</span>
                                    </div>
                                    <div class="qr-camp-list">
                                        {#if !outbound_locked}
                                            <label class="qr-camp-card qr-camp-card--row {outbound_campaign_id === null ? 'is-selected' : ''}">
                                                <input class="qr-camp-card__input" type="radio" bind:group={outbound_campaign_id} value={null}/>
                                                <span class="qr-camp-card__check"><i class="bi bi-check-lg"></i></span>
                                                <span class="qr-camp-card__body">
                                                    <span class="qr-camp-card__title text-body-secondary">Sin saliente</span>
                                                </span>
                                            </label>
                                        {/if}
                                        {#each outbound_campaign_list as opt (opt.id)}
                                            <label class="qr-camp-card qr-camp-card--row {outbound_campaign_id === opt.id ? 'is-selected' : ''} {opt.permit_select === 0 ? 'is-locked' : ''}">
                                                <input class="qr-camp-card__input" type="radio" bind:group={outbound_campaign_id} value={opt.id} disabled={outbound_locked}/>
                                                <span class="qr-camp-card__check"><i class="bi bi-check-lg"></i></span>
                                                <span class="qr-camp-card__body">
                                                    <span class="qr-camp-card__row">
                                                        <span class="qr-camp-card__title text-truncate">{opt.description}</span>
                                                        <span class="qr-camp-card__id">#{opt.id}</span>
                                                    </span>
                                                    <span class="qr-chan-pills">
                                                        <span class="qr-chan-pill qr-chan-pill--out"><i class="bi bi-broadcast-pin"></i>{opt.outbound_type}</span>
                                                        {#if opt.permit_select === 0}<span class="qr-chan-pill qr-chan-pill--req"><i class="bi bi-lock-fill"></i>Obligatoria</span>{/if}
                                                    </span>
                                                </span>
                                            </label>
                                        {/each}
                                    </div>
                                </section>
                            {/if}

                            <!-- Grupos de atención (inbound, multi) -->
                            <section class="qr-camp-section">
                                <div class="qr-camp-head">
                                    <i class="bi bi-people-fill qr-camp-head__ico qr-camp-head__ico--in"></i>
                                    <span class="qr-camp-head__title">Grupos de atención</span>
                                    {#if inbound_campaign_list.length > 0}
                                        <span class="qr-camp-head__count">{inbound_campaigns.length}/{inbound_campaign_list.length}</span>
                                    {/if}
                                </div>
                                <div class="qr-camp-list">
                                    {#each inbound_campaign_list as camp (camp.id)}
                                        <label class="qr-camp-card {inbound_campaigns.includes(camp.id) ? 'is-selected' : ''} {camp.permit_select === 0 ? 'is-locked' : ''}">
                                            <input class="qr-camp-card__input" type="checkbox" value={camp.id}
                                                   bind:group={inbound_campaigns} disabled={camp.permit_select === 0}/>
                                            <span class="qr-camp-card__check"><i class="bi bi-check-lg"></i></span>
                                            <span class="qr-camp-card__body">
                                                <span class="qr-camp-card__row">
                                                    <span class="qr-camp-card__title text-truncate">{camp.name}</span>
                                                    <span class="qr-camp-card__id">#{camp.id}</span>
                                                </span>
                                                <span class="qr-chan-pills">
                                                    {#if camp.enable_audio}<span class="qr-chan-pill qr-chan-pill--audio"><i class="bi bi-telephone-fill"></i>Audio</span>{/if}
                                                    {#if camp.enable_chat}<span class="qr-chan-pill qr-chan-pill--chat"><i class="bi bi-chat-dots-fill"></i>Chat</span>{/if}
                                                    {#if !camp.enable_audio && !camp.enable_chat}<span class="qr-chan-pill qr-chan-pill--none">Sin canales</span>{/if}
                                                    {#if camp.permit_select === 0}<span class="qr-chan-pill qr-chan-pill--req"><i class="bi bi-lock-fill"></i>Obligatoria</span>{/if}
                                                </span>
                                                {#if camp.description}<span class="qr-camp-card__desc text-truncate">{camp.description}</span>{/if}
                                            </span>
                                        </label>
                                    {/each}
                                    {#if inbound_campaign_list.length === 0}
                                        <div class="qr-camp-empty"><i class="bi bi-inbox"></i> No hay grupos de atención disponibles.</div>
                                    {/if}
                                </div>
                            </section>
                        </div>

                            <div class="qr-modal-foot d-flex gap-2">
                                <button disabled={loading} class="btn btn-outline-secondary flex-fill d-flex align-items-center justify-content-center"
                                        onclick={closeCampaignsModal} type="button">
                                    <i class="bi bi-arrow-left me-2"></i>
                                    Volver
                                </button>
                                <button disabled={loading} class="btn btn-success flex-fill d-flex align-items-center justify-content-center"
                                        onclick={handleLogin} type="button">
                                    {#if loading}
                                        <span class="spinner-border spinner-border-sm me-2"></span>
                                    {:else}
                                        <i class="bi bi-box-arrow-in-right me-2"></i>
                                    {/if}
                                    Ingresar
                                </button>
                            </div>
                        </div>
                      </div>
                    </div>
                    {/if}

                </div>
            </div>
        </div>
    </div>
</div>
